export const APP_NAME_FULL = 'Laboratory Information Management System';
export const APP_NAME_SHORT = 'LIMS';

export function appDocumentTitle(pageLabel: string): string {
  return `${pageLabel} · ${APP_NAME_SHORT}`;
}
